<template>
	<div class="divide-y-2 divide-gray-200">
		<my-contracts-form-title v-if="creating" />

		<!-- Date -->
		<offer-edit-date
			:form="form"
			class="p-6"
			:class="creating ? 'pl-24' : ''"
			:setHarvestYearAsMinDate="true"
		/>

		<div v-if="userLocationIsEditable(form.user_location_id)">

			<div class="flex p-6 px-6"
			:class="{ 'pl-24' : creating }"
			>
				<ui-select-group
					class="basis-full sm:basis-[30.75%]"
					v-model="form.user_location_id"
					field="user_location_id"
					type="select"
					:label="__('userLocation')"
					:options="userLocations"
					:form="form"
					:required="true"
					:placeholder="false"
				></ui-select-group>
			</div>
		</div>

		<!-- Parity -->
		<div class="p-6" :class="{'pl-24': creating }">
			<p class="font-medium text-gray-700">
				{{ __("Location") }}
			</p>
			<bid-section-toggleable :flexGrow="false">
				<template v-slot:closed>
					{{ $cropOptions.locationToString(form, locale) }}
				</template>
				<template v-slot:open>
					<offer-edit-location
						:form="form"
						class="p-6 pt-0 pl-0"
						:noLabel="true"
						:hideFobCif="true"
					/>
				</template>
			</bid-section-toggleable>
		</div>

		<ui-modal
			ref="deleteModal"
			:small="true"
			:confirm-label="__('Delete')"
			v-on:confirm="deleteUpload()"
			v-on:dismiss="showFileDeleteModal = false"
			v-on:close="showFileDeleteModal = false"
			v-if="showFileDeleteModal"
			>{{ __("Do you want to delete the document?") }}</ui-modal
		>

		<div :class="creating ? 'pl-24' : 'pl-6'">
			<p class="font-medium text-gray-700 p-6 pb-0 pl-0">
				{{ __("Upload file") }}
			</p>

			<div
				v-if="form.pdf_user_uploads_id && !showUpload"
				class="p-6 pl-0 flex space-x-3 items-center"
			>
				<ui-icon class="h-5 w-5 text-gray-600" name="file" stroke-width="2" />
				<a
					:href="
						form.pdf_user_uploads_id
							? $route('external_contract.pdf', { id: form.id })
							: '#'
					"
					target="_blank"
				>
					{{ form.pdfFilename }}
				</a>
				<a href="#" @click="showFileDeleteModal = true"
					><ui-icon class="text-orange text-xl ml-1" name="fa-trash"
				/></a>
			</div>

			<div v-else-if="!form.pdf_user_uploads_id || showUpload">
				<input
					type="file"
					@input="form.file = $event.target.files[0]"
					v-bind:accept="accept"
					class="form-control-file p-6 pl-0 pt-0"
				/>
				<ui-validation-message :form="form" field="file" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		userLocations: {
			type: Array,
			required: true
		},
		form: {
			type: Object,
			required: true,
		},
		accept: {
			type: String,
			required: false,
			default: "application/pdf, image/jpeg, image/png",
		},
		creating: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			validationMessage: "",
			showUpload: false,
			showFileDeleteModal: false,
		};
	},
	methods: {
		deletePdf() {
			let that = this;
			this.$inertia.delete(
				this.$route("external_contract.upload.delete", {
					id: this.form.id,
				}),
				{
					onFinish() {
						that.showUpload = true;
					},
				}
			);
			//window.parent.location.reload();
		},
		async deleteUpload() {
			const resp = await axios.delete(
				this.$route("external_contract.upload.delete", {
					id: this.form.id,
				})
			);
			this.showUpload = true;
		},
		userLocationIsEditable(id) {
			if(this.userLocations.length > 1){
				return true;
			}

			const selectedUserLocation = this.userLocations.find((location) => location.id === id);
			return !selectedUserLocation;
		}
	},
};
</script>
